//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentScan', {
//        templateUrl: 'views/components/views/consignmentScan/consignmentScan.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'modalService', 'consignmentScanService', function (stateService, utilityService, modalService, consignmentScanService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                barcodeButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('barcode') },
//                    { id: 'calculator', icon: 'fa fa-calculator', color: 'primary', type: 'primary', onClick: () => openCalculator('barcode') },
//                    { id: 'search', icon: 'fas fa-search', color: 'success', type: 'success', onClick: () => scanValue() }
//                ],
//                barcode: ''
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region SCAN VALUE FUNCTION

//            function scanValue() {
//                if (utilityService.validateParmsValue(vm.model.barcode) !== true) return;

//                consignmentScanService.scanConsignment({ barcode: vm.model.barcode }).then((response) => {
//                    if (response[0]) {
//                        clear('barcode');
//                        stateService.go(response[0].webpagename, response[0].parms);
//                    } else {
//                        clear('barcode');
//                    }

//                    clear('barcode');
//                });
//            }

//            // #endregion SCAN VALUE FUNCTION

//            // #region MULTI CLEAR FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'barcode':
//                        if (vm.model.barcode > '') {
//                            vm.model.barcode = '';
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion MULTI CLEAR FUNCTION

//            // #region OPEN CALCULATOR DIALOGUE BOX FUNCTION

//            function openCalculator(id) {
//                switch (id) {
//                    case 'barcode':
//                        modalService.showCalculator(vm.model.barcode).then(function (value) {
//                            vm.model.barcode = value;
//                            scanValue();
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion OPEN CALCULATOR DIALOGUE BOX FUNCTION

//            // #region SUBMIT SEARCH FUNCTION

//            vm.submitSearch = function () {
//                scanValue();
//            }

//            // #endregion SUBMIT SEARCH FUNCTION

//        }]
//    });
//})();
